export default __webpack_public_path__ + "static/media/press_10.86378390.jpg";